import { Component, Input, ViewChild } from '@angular/core';

import { delay, filter, map, Observable, of, switchMap, tap } from 'rxjs';

import {
  GenericParamsComponent,
  InputControlData,
  NtapGlobalConstants
} from '@ntap/core';

import { DynamicFormService } from '@ntap/common';

import { UntypedFormControl } from '@angular/forms';
import { FileUpload } from 'primeng/fileupload';
import {
  ImagePanelItemProviderService,
  ItemWithUrl
} from './services/image-panel-item-provider.service';

@Component({
  selector: 'app-image-panel',
  templateUrl: './image-panel.component.html',
  styleUrls: ['./image-panel.component.scss']
})
export class ImagePanelComponent extends GenericParamsComponent {
  public itemWithImageUrl$: Observable<ItemWithUrl> = of();
  public imageUrl: string | null = null;
  public uploadedUrl: string | null = null;
  public imageCommentInputParam$: Observable<InputControlData> = of();
  public uploadedFiles: Array<File> = [];

  private _formService: DynamicFormService;

  @ViewChild('fileUpload')
  public fileUpload: FileUpload;

  private formControlFiles: UntypedFormControl;
  private formControlComment: UntypedFormControl;

  constructor(protected imageItemProvider: ImagePanelItemProviderService) {
    super();
  }

  @Input()
  set formService(formService: DynamicFormService) {
    if (!formService) {
      return;
    }
    this._formService = formService;
    this.itemWithImageUrl$ = this._formService.formGroup$.pipe(
      switchMap(() => this.imageItemProvider.itemWithImageUrl$),
      delay(0), // moramo cekati da se forma inicijalizira da bi se i kontrola inicijalizirala
      map((item) => {
        // kontrola s ovim imenom sluzi za prijenos podataka datoteke
        // bitno je da je inicijaliziramo nakon sto dodu podaci itema
        if (
          !this._formService.getFormControl(
            NtapGlobalConstants.ATTR_FILE_UPLOAD
          )
        ) {
          this.formControlFiles = this._formService.registerFormControl(
            NtapGlobalConstants.ATTR_FILE_UPLOAD,
            this.uploadedFiles
          );
        } else {
          this.log(
            'ERROR: control with key ' +
              NtapGlobalConstants.ATTR_FILE_UPLOAD +
              ' already registered. Will not override existing control! Check your Form Service instances'
          );
        }
        this.imageUrl = item.imageUrl || this.uploadedUrl;
        return item;
      })
    );
    this.imageCommentInputParam$ =
      this.imageItemProvider.imageCommentInputParam$.pipe(
        delay(0),
        filter((imageCommentInputControl) => !!imageCommentInputControl),
        tap((imageCommentInputControl) => {
          this.formControlComment = this._formService.registerFormControl(
            imageCommentInputControl.attributeMetadata.name,
            this.formControlComment?.getRawValue()
          );
        })
      );
  }

  doDynamicInit() {
    //
  }

  protected doChangedInputParam() {
    //
  }

  protected doChangedOutputParam() {
    //
  }

  clearFiles() {
    this.formControlFiles.setValue([]);
    this.fileUpload.clear();
    this.uploadedFiles = [];
    this.uploadedUrl = null;
    this.imageUrl = null;
  }

  selectFiles(event: {
    originalEvent: Event;
    files: File[];
    currentFiles: File[];
  }) {
    const imageUrl = window.URL.createObjectURL(event.files[0]);
    this.uploadedUrl = imageUrl;
    this.imageUrl = imageUrl;
    const files = [...event.files];
    this.formControlFiles.setValue(files);
    this.fileUpload.clear();
    this.uploadedFiles = files;
    this.formControlFiles.markAsDirty();
  }
}
